<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeRegister"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeRegister" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <v-dialog v-model="dialogConsent" width="500" persistent>
      <v-card data-testid="modal-consent">
        <v-btn
          fab
          @click="scrollToBottom"
          style="position: absolute; right: 6px; bottom: 10px; z-index: 1"
          color="grey darken-2"
          small
          v-if="showScrollIcon"
          class="mx-2"
        >
          <v-icon color="white" size="24">mdi-arrow-down </v-icon>
        </v-btn>

        <v-card-text
          @scroll="handleScroll"
          ref="scrollContainer"
          style="max-height: 90vh; overflow-y: auto"
        >
          <div class="pt-3">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="primary"
              fixed-tabs
              height="56px"
            >
              <v-tab
                href="#tab-1"
                v-if="campaign.is_show_policy"
                @click="
                  acceptConsent = false;
                  disabledTerms = true;
                "
              >
                <span v-html="$t('microsite.privacyPolicy')"></span>
              </v-tab>
              <v-tab
                href="#tab-2"
                v-if="campaign.is_show_terms"
                :disabled="disabledTerms"
              >
                <span v-html="$t('microsite.termAndCondition')"></span>
              </v-tab>

              <v-tabs-items v-model="tab" class="mt-5">
                <v-tab-item :value="'tab-1'">
                  <div
                    class="div-term-cond ql-editor"
                    v-html="formatHtmlDetail(campaign.policy_text)"
                  ></div>
                </v-tab-item>
                <v-tab-item :value="'tab-2'">
                  <div
                    class="div-term-cond ql-editor"
                    v-html="formatHtmlDetail(campaign.terms_text)"
                  ></div>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </div>
          <div ref="scrollTarget" class="text-end">
            <v-btn
              v-if="acceptConsent == false"
              data-testid="btn-next"
              :color="accentColor"
              text
              outlined
              class="px-4"
              style="border-radius: 8px"
              @click="acceptPdPa()"
            >
              {{ $t("microsite.textNext") }}
            </v-btn>

            <v-btn
              v-if="acceptConsent == true"
              data-testid="btn-accept"
              :color="accentColor"
              class="px-4"
              style="border-radius: 8px"
              :style="{
                color: getFontColorBasedOnBg(accentColor),
              }"
              @click="dialogConsent = false"
            >
              {{ $t("microsite.acceptConsent") }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DialogVerifyOtp
      ref="refVerifyOTP"
      v-model="dialogOtp"
      :dialogOtp="dialogOtp"
      :ref_code="ref_code"
      :site="site"
      @close="dialogOtp = false"
      @verifyOtp="verifyOtp"
      @sendOtp="sendOtp"
    ></DialogVerifyOtp>

    <v-footer padless v-if="campaign.is_show_footer">
      <v-col class="text-center footer" cols="12">
        <p class="ql-editor" v-html="campaign.footer_text"></p>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import DialogVerifyOtp from "@/components/dialogVerifyOtp-microsite.vue";
import {
  addClassQlEditorToSDDisplay,
  addDivCustomInputMaskPattern,
  formatHtmlDetailDefault,
  formattedForSave,
  addDropdownPhoneCountry,
  getFontColorBasedOnBg,
  transformJsonCustomInputMask,
  customThemeSurveyJS,
} from "../../../config/general-function";
import { provinces } from "../../../config/location/provinces.js";
import { districts } from "../../../config/location/districts.js";
import { sub_districts } from "../../../config/location/sub_districts.js";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";
import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

export default {
  name: "MicrositeRegister",
  inject: ["isAppLoading"],
  components: {
    Survey,
    DialogVerifyOtp,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: {
      is_show_policy: false,
      policy_text: "",
      is_show_terms: false,
      terms_text: "",
      is_show_footer: false,
    },
    survey: null,
    surveyJson: null,
    header: null,
    consent: false,
    policy: false,
    dialogConsent: false,
    tab: "tab-1",
    themeName: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    dialogOtp: false,
    ref_code: "",
    request_id: "",
    phone: "",
    phoneSendOTP: "",
    isSendOtp: true,
    acceptConsent: false,
    showScrollIcon: false,
    disabledTerms: false,
    accentColor: "blue",

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    this.onInit();
    this.getSurveyAndTheme();
    if (this.campaign.is_use_phone_country) {
      const indexPhone = this.surveyJson.elements.findIndex(
        (x) => x.name == "phone"
      );
      if (indexPhone >= 0) {
        const model = this.surveyJson.elements[indexPhone];
        delete model["validators"];
        this.surveyJson.elements[indexPhone] = model;
      }
    }
    this.themeName = this.campaign.template.name;

    this.surveyJson = this.setQuestionAddress(this.surveyJson);
    this.surveyJson = this.setQuestionBrandBranch(this.surveyJson);
    this.surveyJson = transformJsonCustomInputMask(this.surveyJson);
    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;

    if (this.campaign.is_show_policy == 1 || this.campaign.is_show_terms == 1) {
      this.dialogConsent = true;
    }

    this.disabledField();
    this.handleUploadImage();
    this.handleSubmit();
    this.onValueChanged();
    this.onAfterRenderPage();
    this.onAfterRenderQuestion();
    this.checkMaxUpload();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
    countryList() {
      const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

      const getFlagEmoji = (countryCode) => {
        const codePoints = countryCode
          .toUpperCase()
          .split("")
          .map((char) => 127397 + char.charCodeAt(0));
        return String.fromCodePoint(...codePoints);
      };
      const _countryList = getCountries().map((countryCode) => {
        const dialCode = `+${getCountryCallingCode(countryCode)}`;

        // ดึงชื่อประเทศเต็ม เช่น 'Thailand', 'Japan', 'United States'
        const countryName = regionNames.of(countryCode) || countryCode;
        const flag = getFlagEmoji(countryCode);

        return {
          code: countryCode, // 'TH'
          dialCode: dialCode, // '+66'
          name: countryName, // 'Thailand'
          flag: flag, // '🇹🇭'
          label: `${flag} ${countryName} (${dialCode})`,
        };
      });

      return _countryList.sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    acceptPdPa() {
      this.showScrollIcon = false;
      this.acceptConsent = true;
      this.disabledTerms = false;
      this.tab = "tab-2";
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer;
        if (el) {
          el.scrollTop = 0; // Scroll to the top of the container
        }
      });
    },
    handleScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;

      const threshold = 20;
      setTimeout(() => {
        const bottom =
          el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

        this.showScrollIcon = !bottom && !el.scrollTop == 0;
      }, 100);
    },
    scrollToBottom() {
      if (!this.$refs.scrollContainer) return;
      this.$refs.scrollContainer.scrollTo({
        top: this.$refs.scrollContainer.scrollHeight,
        behavior: "smooth",
      });
    },
    onInit() {
      if (!this.campaign?.policy_text) {
        this.campaign.policy_text = `<div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">${this.$t(
          "microsite.dataNotFound"
        )}</div>`;
      }
      if (!this.campaign?.terms_text) {
        this.campaign.terms_text = `<div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">${this.$t(
          "microsite.dataNotFound"
        )}</div>`;
      }
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
        if (this.campaign.is_show_policy && this.campaign.is_show_terms) {
          this.acceptConsent = false;
          this.disabledTerms = true;
        } else {
          this.acceptConsent = true;
          this.disabledTerms = false;
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.login) {
        let loginJson = surveyJson.login;
        this.header = loginJson["elements"][0];
      }
      if (surveyJson && surveyJson.register) {
        this.surveyJson = surveyJson.register;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).register;
      }
      if (Array.isArray(this.surveyJson?.elements)) {
        for (let item of this.surveyJson.elements) {
          if (item.type == "file" && item.storeDataAsText == undefined) {
            item.storeDataAsText = false;
          }
        }
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
          const _accent = themeList.find((x) => x == "--sjs-primary-backcolor");
          if (_accent) {
            this.accentColor =
              themeJson?.cssVariables[_accent] || this.accentColor;
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    getFontColorBasedOnBg(bg_color) {
      const color = getFontColorBasedOnBg(bg_color, "bw");
      return color;
    },
    disabledField() {
      let phone = this.survey.getQuestionByName("phone");
      let fullname = this.survey.getQuestionByName("fullname");

      // disabled phone field

      if (this.campaign.split_register_page == true) {
        if (this.user && this.user.phone && phone != null) {
          this.survey.getQuestionByName("phone").readOnly = true;
          this.survey.setValue("phone", this.user.phone);
        }
        if (this.user && this.user.fullname && fullname != null) {
          this.survey.getQuestionByName("fullname").readOnly = true;
          this.survey.setValue("fullname", this.user.fullname);
        }
      } else {
        if (
          this.user &&
          this.campaign.split_register_page == false &&
          this.campaign.auto_fill_register_question &&
          this.user.detail
        ) {
          let jsonRegisterQuestion = JSON.parse(
            this.campaign.auto_fill_register_question
          );

          let registerQuestions = jsonRegisterQuestion["question"];
          const registerQuestionsDisable =
            jsonRegisterQuestion["question_disable"] || [];
          registerQuestions.forEach((questionName) => {
            const question = this.survey.getQuestionByName(questionName.trim());
            const answer = this.user["detail"][questionName.trim()];
            if (question && answer != undefined) {
              this.survey.setValue(
                questionName.trim(),
                this.user["detail"][questionName.trim()]
              );
              if (registerQuestionsDisable.includes(questionName.trim())) {
                question.readOnly = true;
              }
              // ========== ========== Address ========== ==========
              if (questionName == "district") {
                const answer_province = this.user["detail"]["province"];
                const district = this.survey.getQuestionByName("district");
                if (district && answer_province) {
                  district.readOnly = answer_province ? false : true;
                  district.choices = districts
                    .filter((x) => x.province_id == answer_province)
                    .map((x) => {
                      return {
                        value: x.id,
                        text: x.name_th,
                      };
                    });
                }
              }
              if (questionName == "sub_district") {
                const answer_district = this.user["detail"]["district"];
                const sub_district =
                  this.survey.getQuestionByName("sub_district");
                if (sub_district && answer_district) {
                  sub_district.readOnly = answer_district ? false : true;
                  sub_district.choices = sub_districts
                    .filter((x) => x.district_id == answer_district)
                    .map((x) => {
                      return {
                        value: x.id,
                        text: x.name_th,
                      };
                    });
                }
              }
              if (questionName == "zip_code") {
                const answer_sub_district = this.user["detail"]["sub_district"];
                const zip_code = this.survey.getQuestionByName("zip_code");
                if (zip_code && answer_sub_district) {
                  let choices = [];
                  const model = sub_districts.find(
                    (x) => x.id == answer_sub_district
                  );
                  for (let item of model.zip_codes) {
                    choices.push({
                      value: `${model.id}_${item}`,
                      text: `${item}`,
                    });
                  }
                  zip_code.choices = choices;
                }
              }
              // ========== ========== ========== ==========
            }
          });
        } else {
          if (this.user && this.user.phone && phone != null) {
            this.survey.getQuestionByName("phone").readOnly = true;
            this.survey.setValue("phone", this.user.phone);
          }
          if (this.user && this.user.fullname && fullname != null) {
            this.survey.getQuestionByName("fullname").readOnly = true;
            this.survey.setValue("fullname", this.user.fullname);
          }
        }
      }

      if (this.user && this.user.status_consent == 1) {
        this.dialogConsent = false;
        this.isSendOtp = false;
      }
    },
    handleUploadImage() {
      this.survey.onUploadFiles.add(async (_, options) => {
        // ========== ========== ========== ==========
        const fileLimitMB = 40;
        if (Array.isArray(options.files) && options.files.length > 0) {
          let checkSize = false;
          for (let item of options.files) {
            if (item?.size / 1000000 > fileLimitMB) {
              checkSize = true;
              break;
            }
          }
          if (checkSize) {
            options.callback("error");
            const errText = this.$t("microsite.maxFileSizeAllowed", {
              size: fileLimitMB,
            });
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2500,
            });
            Toast.fire({
              icon: "error",
              title: errText,
            });
            return;
          }
        }
        // ========== ========== ========== ==========
        const getParam = () => {
          return {
            site_id: this.site.id,
            campaign_id: this.campaign.id,
          };
        };
        options.files.forEach(function (file) {
          const formData = new FormData();
          formData.append("image", file);
          const { site_id, campaign_id } = getParam();
          MicrositeAxios.post(
            `uploadImageTransaction/${site_id}?campaign=${campaign_id}`,
            formData
          )
            .then(({ data }) => {
              if (data.status == "success") {
                options.callback("success", [
                  {
                    file: file,
                    content: data.data?.url,
                  },
                ]);
              }
            })
            .catch((err) => {
              throw err;
            });
        });
      });
    },
    onValueChanged() {
      const _isAppLoading = (param) => {
        this.isAppLoading(param);
      };
      this.survey.onValueChanged.add((sender, options) => {
        const name = options.name;
        const value = options.value;
        const questions = this.survey.getAllQuestions();
        // ========== ========== Set Null Value Invisible Question ========== ==========
        const invisible_questions = questions.filter((x) => !x.visible);
        for (let invisible_question of invisible_questions) {
          const _name = invisible_question.name;
          const model = this.survey.getQuestionByName(_name);
          if (model) {
            this.survey.setValue(_name, null);
          }
        }
        // ========== ========== Address ========== ==========
        if (name == "province") {
          const district = this.survey.getQuestionByName("district");
          if (district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = districts
                .filter((x) => x.province_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            district.readOnly = readOnly;
            district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = district.page;
            page.removeElement(district);
            setTimeout(() => {
              const _province = this.survey.getQuestionByName("province");
              const _page = _province.page;
              const originalIndex = _page.elements.indexOf(_province);
              this.survey.setValue("district", null);
              _page.addElement(district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "district") {
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = sub_districts
                .filter((x) => x.district_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            sub_district.readOnly = readOnly;
            sub_district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = sub_district.page;
            page.removeElement(sub_district);
            setTimeout(() => {
              const _district = this.survey.getQuestionByName("district");
              const _page = _district.page;
              const originalIndex = _page.elements.indexOf(_district);
              this.survey.setValue("sub_district", null);
              _page.addElement(sub_district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "sub_district") {
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code) {
            let list = [];
            let readOnly = true;
            let _value = null;
            if (value) {
              readOnly = false;
              const model = sub_districts.find((x) => x.id == value);
              const zip_codes = model?.zip_codes || [];
              if (zip_codes.length > 0) {
                _value = `${model.id}_${zip_codes[0]}`;
              }
              for (let item of zip_codes) {
                list.push({
                  value: `${model.id}_${item}`,
                  text: `${item}`,
                });
              }
            }
            zip_code.readOnly = readOnly;
            zip_code.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = zip_code.page;
            page.removeElement(zip_code);
            setTimeout(() => {
              const _sub_district =
                this.survey.getQuestionByName("sub_district");
              const _page = _sub_district.page;
              const originalIndex = _page.elements.indexOf(_sub_district);
              this.survey.setValue("zip_code", _value);
              _page.addElement(zip_code, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        // ========== ========== Brand Branch ========== ==========
        const branch_brand_first_questions =
          questions.find((x) => ["branch", "brand"].includes(x.name))?.name ||
          "";
        if (name == branch_brand_first_questions) {
          const second_question =
            branch_brand_first_questions == "branch" ? "brand" : "branch";
          const second = this.survey.getQuestionByName(second_question);
          if (second) {
            let is_same_page = true;
            const first = this.survey.getQuestionByName(
              branch_brand_first_questions
            );
            if (first.page.name != second.page.name) {
              is_same_page = false;
            }
            let list = [];
            let visible = false;
            if (value) {
              visible = true;
              const brands_branches = this.campaign?.brands_branches || [];
              const choice = brands_branches
                .filter(
                  (x) =>
                    x[`${branch_brand_first_questions}_name`] == value &&
                    x[`${second_question}_name`]
                )
                .map((x) => x[`${second_question}_name`]);
              const grouped = Object.groupBy(choice, (item) => item);
              console.log(grouped);
              list = Object.keys(grouped);
            }
            second.visible = visible;
            if (list.length == 0) {
              second.visible = false;
            }
            second.choices = list;
            // ========== ========== ========== ==========
            if (is_same_page) {
              _isAppLoading(true);
              const page = second.page;
              page.removeElement(second);
              setTimeout(() => {
                const _first = this.survey.getQuestionByName(
                  branch_brand_first_questions
                );
                const _page = _first.page;
                const originalIndex = _page.elements.indexOf(_first);
                this.survey.setValue(second_question, null);
                _page.addElement(second, originalIndex + 1);
                _isAppLoading(false);
              }, 100);
            }
          }
        }
        // ========== ========== ========== ==========
      });
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    setQuestionAddress(schema) {
      let pages = schema?.pages || [];
      const setAddress = (elements) => {
        if (Array.isArray(elements)) {
          const province = elements.find((x) => x.name == "province");
          if (province) {
            province.choices = provinces.map((x) => {
              return {
                value: x.id,
                text: x.name_th,
              };
            });
          }
          // ========== ========== ========== ==========
          const district = elements.find((x) => x.name == "district");
          if (district) {
            district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const sub_district = elements.find((x) => x.name == "sub_district");
          if (sub_district) {
            sub_district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const zip_code = elements.find((x) => x.name == "zip_code");
          if (zip_code) {
            zip_code.readOnly = true;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let elements = item?.elements || [];
          elements = setAddress(elements);
          if (item) {
            item.elements = elements;
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        elements = setAddress(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    setQuestionBrandBranch(schema) {
      let pages = schema?.pages || [];
      const brands_branches = this.campaign?.brands_branches || [];
      let first_question = "";
      let second_question = "";
      let flat_question = [];
      let is_same_page = true;
      const setBrandBranch = (elements) => {
        second_question = first_question == "branch" ? "brand" : "branch";
        if (Array.isArray(elements)) {
          const first = elements.find((x) => x.name == first_question);
          if (first) {
            const first_choice = brands_branches
              .filter((x) => x[`${first_question}_name`])
              .map((x) => x[`${first_question}_name`]);
            const grouped = Object.groupBy(first_choice, (item) => item);
            first.choices = Object.keys(grouped);
          }
          // ========== ========== ========== ==========
          const second = elements.find((x) => x.name == second_question);
          if (second && is_same_page) {
            second.visible = false;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let element = item.elements.map((x) => {
            return {
              ...x,
              page: item.name,
            };
          });
          if (Array.isArray(element)) {
            flat_question = [...flat_question, ...element];
          }
        }
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        const branch = flat_question.find((x) => ["branch"].includes(x.name));
        const brand = flat_question.find((x) => ["brand"].includes(x.name));
        if (branch && brand) {
          if (branch.page != brand.page) {
            is_same_page = false;
          }
        }
        if (first_question) {
          for (let item of pages) {
            let elements = item?.elements || [];
            elements = setBrandBranch(elements);
            if (item) {
              item.elements = elements;
            }
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        flat_question = [...elements];
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        elements = setBrandBranch(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    handleSubmit() {
      this.survey.onComplete.add((sender) => {
        this.onSubmit(sender);
      });
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const questionEl = options.htmlElement;
        if (["image_confirm"].includes(options.question.name)) {
          questionEl.style.cursor = "pointer"; // Optional: Change cursor to indicate clickable
          questionEl.onclick = () => {
            if (options.question.name == "image_confirm") {
              const isSurveyHasErrors = this.survey.hasErrors();
              if (isSurveyHasErrors) return;
              this.onSubmit(sender);
            }
          };
        } else if (["phone"].includes(options.question.name)) {
          if (this.campaign.is_use_phone_country) {
            const countries = this.countryList;
            addDropdownPhoneCountry(questionEl, countries, "TH");
          }
        }
      });
    },
    validatePhoneCountry(sender, phone) {
      const questionEl = sender.getQuestionByName("phone")?.getWrapperElement();
      const selectedCountry = questionEl?.dataset.selectedCountry || "TH";
      // ========== ========== ========== ==========
      const isCleanInput = /^[0-9\s\-+]+$/.test(phone);
      const phoneNumber = parsePhoneNumberFromString(
        phone || "",
        selectedCountry
      );
      const isStrictMatch =
        isCleanInput && phoneNumber && phoneNumber.isValid();
      if (!isStrictMatch) {
        return null;
      }
      const formattedE164Phone = phoneNumber.number;
      phone = formattedE164Phone;
      return phone;
    },
    async onSubmit(sender) {
      let phone = (sender?.data?.phone || "").trim();
      if (this.campaign.is_use_phone_country) {
        const _validatePhoneCountry = this.validatePhoneCountry(sender, phone);
        if (!_validatePhoneCountry) {
          sender.clear(false);
          const targetQuestion = sender.getQuestionByName("phone");
          if (targetQuestion) {
            targetQuestion.addError(this.$t("microsite.invalidPhoneNumber"));
            targetQuestion.focus();
          }
          return;
        } else {
          phone = _validatePhoneCountry;
        }
      }
      this.phone = phone;
      this.phoneSendOTP = (sender?.data?.phone || "").trim();
      // ========== ========== ========== ==========
      try {
        const validatePhone =
          this.phoneSendOTP && /^0[689]\d{8}$/.test(this.phoneSendOTP);
        if (this.campaign.is_use_otp && this.isSendOtp && validatePhone) {
          this.sendOtp();
        } else {
          this.submitTransaction();
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            text: error.response.data.message,
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.go(0);
          });
      }
    },
    async submitTransaction() {
      this.isAppLoading(true);
      if (this.survey.data.phone) {
        this.survey.data.phone = this.phone;
      }
      // Set user data in Vuex store
      this.$store.commit("microsite/SET_USER", {
        user: {
          phone: this.survey.data.phone,
          line_id: this.user.line_id,
        },
      });
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(
        this.survey.jsonObj,
        this.survey.data
      );
      // ========== ========== ========== ==========
      MicrositeAxios.post(`submitTransaction/${this.campaign.id}`, {
        phone: formatJson.phone,
        fullname: formatJson.fullname != undefined ? formatJson.fullname : null,
        amount: formatJson.amount != undefined ? formatJson.amount : null,
        orderId: formatJson.orderId != undefined ? formatJson.orderId : null,
        surveyResponseJson: JSON.stringify(formatJson),
      })
        .then((res) => {
          const dataResponse = res?.data?.data;
          if (dataResponse) {
            if (
              dataResponse.microsite.split_register_page == true &&
              res?.data?.status == "registered"
            ) {
              const userExists = res?.data?.data?.user;
              this.$store.commit("microsite/SET_USER", {
                user: {
                  phone: userExists ? userExists.phone : this.user.phone,
                  fullname: userExists ? userExists.fullname : null,
                  line_id: userExists ? userExists.line_id : null,
                  status_consent: userExists ? userExists.status_consent : null,
                },
              });
              this.$router.push({ name: "microsite-menu" });
            }
            if (dataResponse.microsite?.template_id == 4) {
              if (!dataResponse.transaction) {
                this.$swal
                  .fire({
                    icon: "success",
                    title: this.$t("microsite.registerSuccess"),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then(() => {
                    return this.$router.push({ name: "microsite-menu" });
                  });
              }
            } else if (dataResponse.microsite?.template_id == 5) {
              if (
                dataResponse.transaction &&
                dataResponse.is_show_game == true
              ) {
                this.$router.push({ name: "microsite-game" });
              } else {
                this.$router.push({ name: "microsite-menu" });
              }
            } else if (
              (dataResponse.microsite?.template_id == 1 ||
                dataResponse.microsite?.template_id == 2) &&
              dataResponse.microsite?.split_register_page
            ) {
              this.$router.push({ name: "microsite-menu" });
            } else {
              setTimeout(() => {
                this.$router.push({ name: "microsite-thankyou" });
              }, 1000);
            }
          } else {
            this.$swal
              .fire({
                icon: "error",
                title: this.$t("microsite.errSubmissionFailed"),
                showConfirmButton: false,
                timer: 1500,
              })
              .then(() => {
                this.$router.go(0);
              });
          }
        })
        .catch((error) => {
          this.$swal
            .fire({
              icon: "error",
              text:
                error.response?.data?.message ||
                this.$t("microsite.errSubmissionFailed"),
              showConfirmButton: true,
            })
            .then(() => {
              this.$router.push({ name: "microsite-login" });
            });
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    checkMaxUpload() {
      this.survey.onValidateQuestion.add((sender, options) => {
        const value = options.value;
        const question = options.question;
        const type = question?.getType();
        if (type == "file") {
          const maxUpload = question?.maxUpload || question?.jsonObj?.maxUpload;
          if (value?.length > maxUpload) {
            options.error = this.$t("microsite.maxFilesAllowed", {
              count: maxUpload,
            });
          }
        }
      });
    },
    sendOtp() {
      this.isAppLoading(true);
      this.dialogOtp = true;

      MicrositeAxios.post("sendOtpMicrosite", {
        mobile: `${this.phoneSendOTP}`,
        site_id: this.campaign.site_id,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.dialogOtp = true;
            this.ref_code = res.data.data.ref_code;
            this.request_id = res.data.data.request_id;
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
            // this.$router.go(0);
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    verifyOtp(code) {
      this.isAppLoading(true);
      MicrositeAxios.post("verifyOtpMicrosite", {
        request_id: this.request_id,
        code: code,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal
              .fire({
                icon: "success",
                title: this.$t("microsite.successOTPVerified"),
                showConfirmButton: false,
                timer: 1500,
              })
              .then(() => {
                this.dialogOtp = false;
                this.submitTransaction();
              });
          }
        })
        .catch((err) => {
          if (this.$refs.refVerifyOTP) {
            this.$refs.refVerifyOTP.clearOTP();
          }
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
  },
};
</script>

<style scoped>
.div-term-cond {
  color: initial;
}
::v-deep .footer p {
  word-break: break-all;
  margin-bottom: 0px !important;
}
::v-deep .v-footer {
  margin-top: auto !important;
  margin-bottom: 0px !important;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}

/* ในกรณีที่มี Component Panel */
::v-deep .sd-panel .sd-row:first-of-type {
  width: 100% !important;
  margin-left: 0px !important;
}
::v-deep .sd-panel .sd-row--multiple > div:first-of-type {
  padding-left: 0px !important;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
